import { createApp } from 'vue';

import App from './App';
import Toaster from "@meforma/vue-toaster";
import { Vue3Mq } from "vue3-mq";

import axios from 'axios';

import { router } from './router';
import { store } from './stores';
import { Cookie, Toast } from './utils';

import BaseComponents from  './components';
import Directives from './utils/directive';

import 'boxicons/css/boxicons.min.css';

// Font-awesome icons package
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
library.add(fas);
import { fab } from "@fortawesome/free-brands-svg-icons";
library.add(fab);
import { far } from "@fortawesome/free-regular-svg-icons";
library.add(far);
import { dom } from "@fortawesome/fontawesome-svg-core";
dom.watch();

if (Cookie.get(process.env.VUE_APP_ACCESS_TOKEN_STORAGE) !== null)
{
    const authorization = `Bearer ${Cookie.get(process.env.VUE_APP_ACCESS_TOKEN_STORAGE)}`;

    axios.defaults.headers.common.Authorization = authorization;

    store.dispatch('auth/loadUser');
}

const app = createApp(App)
    .use(Toaster)
    .use(store)
    .use(router)
    .use(Vue3Mq, {
        preset: 'devices'
    });

BaseComponents.register(app);
Toast.register(app);
Directives.register(app);

app.component("font-awesome-icon", FontAwesomeIcon);
app.mount('#app')
